import { createApp } from 'vue'
import App from './App.vue'
import { createUnhead } from '@unhead/vue'
import { createPinia } from 'pinia'
import router from '@/router'
import parallaxMouse from './directives/parallaxMouse'
import '@/assets/scss/main.scss'
import inputmaskDirective from './directives/inputmask'

const app = createApp(App)

app.use(router)
app.use(createUnhead())
app.use(createPinia())

app.directive('parallax', parallaxMouse)
app.directive('mask', inputmaskDirective)

app.mount('#app')
